import React from "react";
import CodeBlock from "../Code";
const HealthDescription3 = () => {
  return (
    <>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>건강보험공단 질환예측 요청</h3>
          <p>
            건강보험공단 건강검진 결과 API를 사용하기 위해 먼저 다음 URI를 POST
            방식으로 호출해야 합니다.
          </p>
          <CodeBlock code={`POST /fetch_prediction/{svc_idx}`}></CodeBlock>
          <h4 style={{ marginTop: `20px` }}>svc_idx 설명</h4>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col" style={{ width: `20%` }}>
                    scv_idx
                  </th>
                  <th scope="col" style={{ width: `20%` }}>
                    TYPE
                  </th>
                  <th scope="col" style={{ width: `60%` }}>
                    설명
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>1</td>
                  <td style={{ color: `#5DAE46` }}>integer</td>
                  <td>건강나이 알아보기</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>2</td>
                  <td style={{ color: `#5DAE46` }}>integer</td>
                  <td>뇌졸중 예측</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>3</td>
                  <td style={{ color: `#5DAE46` }}>integer</td>
                  <td>당뇨병 예측</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>4</td>
                  <td style={{ color: `#5DAE46` }}>integer</td>
                  <td>만성신장질환 예측</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>5</td>
                  <td style={{ color: `#5DAE46` }}>integer</td>
                  <td>심근경색 예측</td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>6</td>
                  <td style={{ color: `#5DAE46` }}>integer</td>
                  <td>심뇌혈관 예측</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Request</h3>
          <p>
            질환예측에 필요한 요청헤더에 다음과 같은 파라미터를 작성해야합니다.
          </p>
          <CodeBlock
            code={`
          [HTTP Request Header]
          {
                          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          ></CodeBlock>
          <p>
            질환예측 API에 필요한 요청 본문에 다음과 같은 파라미터를 작성해야
            합니다.
          </p>
          <CodeBlock
            code={`
            [HTTP Request Body]
            {
                  "cookie_str ": "string", ### 세션쿠키 문자열                  
            }
            `}
          ></CodeBlock>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col" style={{ width: `20%` }}>
                    Field
                  </th>
                  <th scope="col" style={{ width: `20%` }}>
                    TYPE
                  </th>
                  <th scope="col" style={{ width: `60%` }}>
                    설명
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>cookie_str</td>
                  <td style={{ color: `#5DAE46` }}>string</td>
                  <td>세션 쿠키 문자열</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>공동인증서인증 하면 아래와 같은 데이터를 보냅니다.</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
          
                [HTTP Response Body]
                {
                  "cookie_str": "string",
                  "code": "string",
                  "msg": "정상 | 오류 | ...",
                  "data": {
                    "key": "val",
                    "key2": "val2"
                  },
                  "text": "<html>...</html>"
                }                                        }
                `}
          ></CodeBlock>
          <div
            style={{
              display: `flex`,
              padding: `10px`,
              backgroundColor: `#D5D8DB`,
              fontSize: `15px`,
              fontWeight: `600`,
              justifyContent: `center`,
            }}
          >
            <span style={{ color: `#CE4241` }}>svc_idx</span>의 입력값에 따라{" "}
            <span style={{ color: `#CE4241` }}>data</span>의 값이 변경됩니다. 각{" "}
            <span style={{ color: `#CE4241` }}>svc_idx</span>에 대응하는 데이터
            구조는 다를 수 있으며, 반환되는 데이터는 요청한 서비스의 종류에 따라
            달라집니다.
          </div>
          <div style={{ height: `50px` }}></div>
          <div>
            <h4>1) 건강나이 알아보기 (예시)</h4>
            <CodeBlock
              code={`
            "data": {
              "realAge": "33세",
              "healthAge": "30세",
              "birthDate": "1991.01.01",
              "name": "홍길동",
              "gender": "남성",
              "checkupDate": "2023.09.22",
              "height": "150.2cm",
              "weight": "60.7kg",
              "riskFactor": {
                "waistCircumference": "60",
                "systolicBloodPressure": "90",
                "fastingBloodSugar": "59",
                "hdlCholesterol": "35",
                "triglycerides": "80"
              }
            `}
            ></CodeBlock>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr class="table-secondary">
                    <th scope="col" style={{ width: `33%` }}>
                      Field
                    </th>
                    <th scope="col" style={{ width: `33%` }}>
                      Type
                    </th>
                    <th scope="col" style={{ width: `34%` }}>
                      설명
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.realAge</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>실제 나이</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.healthAge</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>건강 나이. 신체적 건강 상태를 반영한 나이</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.birthDate</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>생년월일</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.name</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>사용자의 이름</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.gender</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>성별</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.height</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>키</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.weight</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>몸무게</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.riskFactor</td>
                    <td style={{ color: `#5DAE46` }}>object</td>
                    <td>주요 건강 위험 요소들이 포함된 객체</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.data.riskFactor.waistCircumference
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>허리둘레</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactor.systolicBloodPressure
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>수축기 혈압</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactor.fastingBloodSugar
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>공복혈당</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactor.hdlCholesterol
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>HDL 콜레스테롤 수치</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactor.triglycerides
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>중성지방</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.checkupDate</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>건강검진일</td>
                  </tr>
                </tbody>
              </table>
              <div style={{ height: `50px` }}></div>
              <div>
                <h4>2) 뇌졸중 예측 (예시)</h4>
                <CodeBlock
                  code={`
                  "data": {
                    "prediction": "3%",
                    "rank": "53",
                    "description": "string",
                    "riskFactors": [
                      {
                        "name": "체질량지수",
                        "value": "20.0",
                        "label": "보통",
                        "normalValue": "18.5-24.9",
                        "similarGroupAverage": "20.0"
                      },
                      {
                        "name": "허리둘레",
                        "value": "100.0",
                        "label": "보통",
                        "normalValue": "90cm 미만",
                        "similarGroupAverage": "80.1"
                      },
                      {
                        "name": "SGPT",
                        "value": "51.0",
                        "label": "보통",
                        "normalValue": "35U/L 이하",
                        "similarGroupAverage": "16.6"
                      },
                      {
                        "name": "이완기혈압",
                        "value": "70.0",
                        "label": "보통",
                        "normalValue": "80mmHg 미만",
                        "similarGroupAverage": "70.4"
                      },
                      {
                        "name": "총콜레스테롤",
                        "value": "180.0",
                        "label": "보통",
                        "normalValue": "200g/dL 미만",
                        "similarGroupAverage": "185.5"
                      }
            `}
                ></CodeBlock>
              </div>
              <div style={{ height: `50px` }}></div>
              <div>
                <h4>3) 당뇨병 예측 (예시)</h4>
                <CodeBlock
                  code={`
                  "data": {
                    "prediction": "10%",
                    "rank": "50",
                    "description": "string",
                    "riskFactors": [
                      {
                        "name": "체질량지수",
                        "value": "20.0",
                        "label": "보통",
                        "normalValue": "18.5-24.9",
                        "similarGroupAverage": "22.1"
                      },
                      {
                        "name": "SGOT",
                        "value": "20.0",
                        "label": "보통",
                        "normalValue": "40U/L 이하",
                        "similarGroupAverage": "19.9"
                      },
                      {
                        "name": "SGPT",
                        "value": "50.0",
                        "label": "보통",
                        "normalValue": "35U/L 이하",
                        "similarGroupAverage": "16.6"
                      },
                      {
                        "name": "총콜레스테롤",
                        "value": "180.0",
                        "label": "보통",
                        "normalValue": "200g/dL 미만",
                        "similarGroupAverage": "185.5"
                      },
                      {
                        "name": "공복혈당",
                        "value": "87.0",
                        "label": "보통",
                        "normalValue": "100mg/dL 미만",
                        "similarGroupAverage": "90.6"
                      }
                    ]
                  }
            `}
                ></CodeBlock>
              </div>
              <div style={{ height: `50px` }}></div>
              <div>
                <h4>4) 만성신장질환 예측 (예시)</h4>
                <CodeBlock
                  code={`
                  "data": {
                    "prediction": "9%",
                    "rank": "50",
                    "description": "string",
                    "riskFactors": [
                      {
                        "name": "체질량지수",
                        "value": "20.0",
                        "label": "보통",
                        "normalValue": "18.5-24.9",
                        "similarGroupAverage": "22.1"
                      },
                      {
                        "name": "LDL",
                        "value": "130.0",
                        "label": "보통",
                        "normalValue": "130mg/dL 미만",
                        "similarGroupAverage": "103.0"
                      },
                      {
                        "name": "크레아티닌",
                        "value": "1.0",
                        "label": "보통",
                        "normalValue": "1.5mg/dL 이하",
                        "similarGroupAverage": "0.7"
                      },
                      {
                        "name": "공복혈당",
                        "value": "87.0",
                        "label": "보통",
                        "normalValue": "100mg/dL 미만",
                        "similarGroupAverage": "90.6"
                      },
                      {
                        "name": "SGOT",
                        "value": "33.0",
                        "label": "보통",
                        "normalValue": "40U/L 이하",
                        "similarGroupAverage": "19.9"
                      }
                    ]
                  }
            `}
                ></CodeBlock>
              </div>
              <div style={{ height: `50px` }}></div>
              <div>
                <h4>4) 만성신장질환 예측 (예시)</h4>
                <CodeBlock
                  code={`
                  "data": {
                    "prediction": "9%",
                    "rank": "50",
                    "description": "string",
                    "riskFactors": [
                      {
                        "name": "체질량지수",
                        "value": "20.0",
                        "label": "보통",
                        "normalValue": "18.5-24.9",
                        "similarGroupAverage": "22.1"
                      },
                      {
                        "name": "LDL",
                        "value": "130.0",
                        "label": "보통",
                        "normalValue": "130mg/dL 미만",
                        "similarGroupAverage": "103.0"
                      },
                      {
                        "name": "크레아티닌",
                        "value": "1.0",
                        "label": "보통",
                        "normalValue": "1.5mg/dL 이하",
                        "similarGroupAverage": "0.7"
                      },
                      {
                        "name": "공복혈당",
                        "value": "87.0",
                        "label": "보통",
                        "normalValue": "100mg/dL 미만",
                        "similarGroupAverage": "90.6"
                      },
                      {
                        "name": "SGOT",
                        "value": "33.0",
                        "label": "보통",
                        "normalValue": "40U/L 이하",
                        "similarGroupAverage": "19.9"
                      }
                    ]
                  }
            `}
                ></CodeBlock>
              </div>
              <div style={{ height: `50px` }}></div>
              <div>
                <h4>5) 심근경색 예측</h4>
                <CodeBlock
                  code={`
                  "data": {
                    "prediction": "13%",
                    "rank": "20",
                    "description": "string",
                    "riskFactors": [
                      {
                        "name": "체질량지수",
                        "value": "20.2",
                        "label": "보통",
                        "normalValue": "18.5-24.9",
                        "similarGroupAverage": "22.1"
                      },
                      {
                        "name": "공복혈당",
                        "value": "87.0",
                        "label": "보통",
                        "normalValue": "100mg/dL 미만",
                        "similarGroupAverage": "90.6"
                      },
                      {
                        "name": "SGPT",
                        "value": "35.0",
                        "label": "보통",
                        "normalValue": "35U/L 이하",
                        "similarGroupAverage": "16.6"
                      },
                      {
                        "name": "허리둘레",
                        "value": "90.0",
                        "label": "보통",
                        "normalValue": "90cm 미만",
                        "similarGroupAverage": "74.1"
                      },
                      {
                        "name": "이완기혈압",
                        "value": "70.0",
                        "label": "보통",
                        "normalValue": "80mmHg 미만",
                        "similarGroupAverage": "70.4"
                      }
                    ]
                  }
            `}
                ></CodeBlock>
              </div>
              <div style={{ height: `50px` }}></div>
              <div>
                <h4>6) 심뇌혈관 예측</h4>
                <CodeBlock
                  code={`
                  "data" : {
                    'prediction': '13%',
                     'rank': '57',
                      'description': 'sting',
                      'riskFactors': [
                      {
                        'name': '체질량지수',
                        'value': '28.9',
                        'label': '관심3',
                        'normalValue': '18.5-24.9',
                        'similarGroupAverage': '22.1'
                        },
                       {
                        'name': '총콜레스테롤',
                        'value': '234.0',
                        'label': '관심3',
                        'normalValue': '200g/dL 미만',
                        'similarGroupAverage': '185.5'
                        },
                       {'name': '허리둘레',
                        'value': '50.0',
                        'label': '보통',
                        'normalValue': '90cm 미만',
                        'similarGroupAverage': '74.1'
                        },
                       {
                        'name': '수축기혈압',
                        'value': '138.0',
                        'label': '관심3',
                        'normalValue': '120mmHg 미만',
                        'similarGroupAverage': '111.8'
                        },
                       {
                        'name': '감마지피티',
                        'value': '121.0',
                        'label': '고위험',
                        'normalValue': '11-63U/L',
                        'similarGroupAverage': '18.9'
                        }
                       ]
                      }
            `}
                ></CodeBlock>
              </div>
              <table class="table table-bordered">
                <thead>
                  <tr class="table-secondary">
                    <th scope="col" style={{ width: `33%` }}>
                      Field
                    </th>
                    <th scope="col" style={{ width: `15%` }}>
                      Type
                    </th>
                    <th scope="col" style={{ width: `49%` }}>
                      설명
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.prediction</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>예측된 위험 확률 값</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.rank</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>위험도를 나타내는 순위. 100명 중의 순위로 표현</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.description</td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>
                      분속 결과 및 예측에 대한 상세 설명. 결과에 대한 배경 설명,
                      해석 가이드를 제공
                    </td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>data.riskFactors</td>
                    <td style={{ color: `#5DAE46` }}>array</td>
                    <td>건강 위험 요인 목록</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactors[].name
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>위험 요인 이름</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactors[].value
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>개인의 측정값</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactors[].label
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>위험 수준에 대한 분류</td>
                  </tr>{" "}
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactors[].normalValue
                    </td>
                    <td style={{ color: `#5DAE46` }}>object</td>
                    <td>해당 위험 요인의 정상 범위 값</td>
                  </tr>
                  <tr>
                    <td style={{ color: `#CE4241` }}>
                      data.riskFactors[].similarGroupAverage
                    </td>
                    <td style={{ color: `#5DAE46` }}>string</td>
                    <td>유사 집단의 평균 값</td>
                  </tr>{" "}
                </tbody>
              </table>
            </div>
          </div>
          <div style={{ height: `50px` }}></div>
          <h3>오류코드</h3>
          <p>다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
            code={`
            {
              "code": "FETCH_PREDICTION:FAILED_AGREEMENT_REQUIRED",
              "msg": "이용자 약관동의가 필요한 사용자입니다.",
              "data": {},
              "text": "HTML 원본"
            }
            `}
          ></CodeBlock>
          <p>
            응답 본문의 분석된 결과 “data(JSON)”는 다음과 같은 내용으로 이루어져
            있습니다.
          </p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col" style={{ width: `20%` }}>
                    FILD
                  </th>
                  <th scope="col" style={{ width: `20%` }}>
                    TYPE
                  </th>
                  <th scope="col" style={{ width: `60%` }}>
                    설명
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>code</td>
                  <td style={{ color: `#5DAE46` }}>string</td>
                  <td>
                    오류 또는 성공 여부를 나타내는 코드. 오류 발생 시에는 실패
                    유형에 따라 특정 코드가 할당됩니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>msg</td>
                  <td style={{ color: `#5DAE46` }}>string</td>
                  <td>
                    오류 또는 성공에 대한 상세 메시지. 오류가 발생한 이유나
                    상황에 대해 설명합니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>cookie_str</td>
                  <td style={{ color: `#5DAE46` }}>string</td>
                  <td>
                    성공 또는 오류와 관계없이 반환되는 세션 쿠키 문자열입니다.
                    실패 시에는 빈 문자열을 반환합니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>data</td>
                  <td style={{ color: `#5DAE46` }}>string</td>
                  <td>
                    서비스에 처리 결과 또는 오류 발생 시에는 빈 데이터를
                    포함합니다. 오류 발생 시에는 {} 와 같은 빈 값을 반환합니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>text</td>
                  <td style={{ color: `#5DAE46` }}>string</td>
                  <td>원본 HTML 텍스트를 반환합니다.</td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginTop: `40px`, marginBottom: `40px` }}>
              <h3>주요 오류 코드와 메시지 설명</h3>
            </div>
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col" style={{ width: `30%` }}>
                    FILD
                  </th>
                  <th scope="col" style={{ width: `35%` }}>
                    MSG
                  </th>
                  <th scope="col" style={{ width: `35%` }}>
                    설명
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: `#CE4241` }}>
                    ERROR:FAILED_PARSING_COOKIE_STR
                  </td>
                  <td>"cookie_str파싱 실패. cookie_str을 확인해주세요.”</td>
                  <td>
                    cookie_str를 파싱하는 중 오류가 발생했을 때 반환되는
                    코드입니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>
                    FETCH_PREDICTION:FAILED_AGREEMENT_REQUIRED
                  </td>
                  <td>"이용자 약관동의가 필요한 사용자입니다."</td>
                  <td>
                    해당 사용자가 서비스를 이용하기 전에 약관에 동의해야 함을
                    나타냅니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>
                    FETCH_PREDICTION:FAILED_NO_LOGIN
                  </td>
                  <td>"로그인을 먼저 진행해주세요"</td>
                  <td>
                    사용자가 로그인하지 않았거나 세션이 만료된 경우에 반환되는
                    코드입니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>
                    FETCH_PREDICTION:FAILED_NO_DATA
                  </td>
                  <td>"건강검진을 받은 후 다시 이용해주세요."</td>
                  <td>
                    해당 서비스에 필요한 건강검진 데이터가 없을 때 반환되는 오류
                    코드입니다.
                  </td>
                </tr>
                <tr>
                  <td style={{ color: `#CE4241` }}>FETCH_PREDICTION:FAILED</td>
                  <td>"기타 오류"</td>
                  <td>
                    처리 중 알 수 없는 오류가 발생했을 때 반환되는 일반적인 실패
                    코드입니다.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <p>질환예측 API의 오류 목록은 다음과 같습니다.</p>
          <CodeBlock
            code={`[HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }`}
          ></CodeBlock>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
export default HealthDescription3;
